import DOMPurify from 'dompurify';

/**
 * 净化 HTML 邮件，防止 XSS。
 * 允许常见邮件标签，禁止 script/事件处理器等。
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button'],
    FORBID_ATTR: [
      'onerror',
      'onload',
      'onclick',
      'onmouseover',
      'onfocus',
      'onmouseenter',
      'formaction',
    ],
    ALLOW_DATA_ATTR: false,
  });
}

/**
 * 生成 srcDoc：沙箱样式 + 净化后的 HTML。
 */
export function buildSafeSrcDoc(html: string): string {
  const clean = sanitizeHtml(html);
  return `<!DOCTYPE html><html><head><meta charset="utf-8" />
<meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src data: https: http:; style-src 'unsafe-inline'; font-src data: https: http:;" />
<style>
  body { font-family: Segoe UI, PingFang SC, Microsoft YaHei, sans-serif; color: #111; margin: 16px; line-height: 1.5; word-break: break-word; }
  img { max-width: 100%; height: auto; }
  a { color: #1a5cff; }
  pre { white-space: pre-wrap; }
</style></head><body>${clean}</body></html>`;
}
